export class CancellationReason {
  id?: number;
  name?: string;

  constructor(opts?: Partial<CancellationReason>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.name != null) {
      this.name = opts.name;
    }
  }
}
